<div class="add-daily-meal-wrapper lg:min-w-[55vw]">
  <div class="heading-section flex flex-col md:flex-row">
    <div class="form-wrapper">
      <div class="heading flex items-center">
        Enter Physical Activity
        <app-icon
          [matTooltip]="'Enter in Minutes and Intensity, or enter steps'"
          class="tooltip-icon"
          matTooltipClass="custom-tooltip"
          matTooltipPosition="below"
          svgIcon="info"></app-icon>
      </div>
      <div class="separator-wrapper">
        <hr class="separator" />
      </div>
      <div class="p-10">
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]">
            Time of day<span class="asterisk ml-[0.5rem]">*</span>
          </span>
          <app-filter-dropdown
            [enableClearSelection]="true"
            [loading]="todLoading"
            [options]="timeOfDayType"
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="todType"
            [error]="errorMessages['todType']"
            placeholder="Select one"
            type="small"
          >
          </app-filter-dropdown>
        </div>
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]">
            Activity<span class="asterisk ml-[0.5rem]">*</span>
          </span>
          <app-text-input
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="name"
            [error]="errorMessages['name']"
            placeholder="Add Activity"
            type="small"
          >
          </app-text-input>
        </div>
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]"> Minutes </span>
          <app-number-input
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="duration"
            [error]="errorMessages['duration']"
            placeholder="minutes"
            type="small"
          >
          </app-number-input>
        </div>
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]"> Intensity </span>
          <app-filter-dropdown
            [enableClearSelection]="true"
            [options]="intensityType"
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="intensity"
            [error]="errorMessages['intensity']"
            placeholder="Select one"
            type="small"
          >
          </app-filter-dropdown>
        </div>
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]"> No. of steps </span>
          <app-number-input
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="noOfSteps"
            [error]="errorMessages['noOfSteps']"
            placeholder="Number of steps"
            type="small"
            [showNumberSeparator]="true"
          >
          </app-number-input>
        </div>
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]">
            Activity Points
          </span>
          <app-number-input
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="points"
            placeholder="Add Activity Points"
            type="small"
            [showNumberSeparator]="true"
          >
          </app-number-input>
        </div>
        <span
          class="time-error-text"
          *ngIf="showPointError"
        >
          Enter in Minutes and Intensity, or enter steps
        </span>
        <div class="form-control w-full flex justify-between items-center">
          <span class="form-label min-w-[28%] max-w-[28%]">
            Comments
          </span>
          <app-text-area-input
            [parentFormGroup]="form"
            class="min-w-[70%] max-w-[70%] form-field"
            controlName="comments"
            placeholder="Add comments (optional)"
            type="small"
            [maxLength]="2000"
          >
          </app-text-area-input>
        </div>
      </div>
      <div class="separator-wrapper">
        <hr class="separator" />
      </div>
      <div class="w-full">
        <div class="flex justify-end button-wrapper">
          <app-icon
            *ngIf="!form.invalid && +form.controls['points'].value"
            (click)="onAddPhysicalActivity()"
            class="action-icon"
            svgIcon="check-circle"
          ></app-icon>
          <app-icon
            *ngIf="form.invalid || !+form.controls['points'].value"
            class="action-icon"
            svgIcon="check-circle-disabled"
          ></app-icon>
          <app-icon
            (click)="onCloseModel()"
            class="action-icon close-icon"
            svgIcon="cross-red-circle"
          ></app-icon>
        </div>
      </div>
    </div>
    <div class="section-wrapper">
      <div class="heading"> Select Activity </div>
      <div class="separator-wrapper">
        <hr class="separator" />
      </div>
      <div
        (scrolled)="onScroll()"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
        [scrollWindow]="false"
        class="table-wrapper overflow-y-scroll"
        infiniteScroll
      >
        <table
          [dataSource]="dataSource"
          mat-table
        >
          <ng-container
            [sticky]="true"
            matColumnDef="activity"
          >
            <th
              *matHeaderCellDef
              class="min-w-[20rem] max-w-[20rem]"
              mat-header-cell
            >
              <div class="th-cell"> Activity </div>
            </th>
            <td
              *matCellDef="let eachRow; let index = index"
              mat-cell
              class="min-w-[20rem] max-w-[20rem]"
            >
              <div class="td-cell">
                <div class="daily-tracker-title text-wrapper">
                  {{ eachRow?.name }}
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="intensity">
            <th
              *matHeaderCellDef
              class="min-w-[10rem] max-w-[10rem]"
              mat-header-cell
            >
              <div class="th-cell daily-tracker-title"> Intensity </div>
            </th>
            <td
              *matCellDef="let eachRow"
              mat-cell
              class="min-w-[10rem] max-w-[10rem]"
            >
              <div
                class="td-cell daily-tracker-content daily-tracker-title text-wrapper flex items-center"
              >
                {{ eachRow?.intensity }}
                <app-icon
                  *ngIf="getIntensityIcon(eachRow?.intensity)"
                  [svgIcon]="getIntensityIcon(eachRow?.intensity)"
                  class="ml-2"
                ></app-icon>
              </div>
            </td>
          </ng-container>
          <tr
            *matHeaderRowDef="colDef; sticky: true"
            mat-header-row
          ></tr>
          <tr
            *matRowDef="let row; columns: colDef"
            mat-row
          ></tr>
        </table>
        <div
          *ngIf="loading"
          [ngClass]="{ initial: !dataSource?.data?.length }"
          class="table-loader w-full flex justify-center items-center"
        >
          <mat-spinner />
        </div>
        <div
          *ngIf="!dataSource?.length && !loading"
          class="no-data flex flex-col justify-center items-center"
        >
          <div class="text"> No Data Found </div>
        </div>
      </div>
    </div>
  </div>
</div>
